import { Component, AfterViewInit, EventEmitter, OnInit, Output, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, Subscriber } from 'rxjs';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.scss']
})
export class PaymentHistoryComponent implements OnInit {
  payHistory : FormGroup;
  payHistoryData: any;
  totalpaid: any;
  Currency: any;
  constructor(private fb: FormBuilder,
    public umsService: UmsService,public dialogRef1: MatDialogRef<PaymentHistoryComponent>,
    public dialog: MatDialog, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe, @Inject(MAT_DIALOG_DATA) public data: any,) { }
    tempCo
    StudentDocumentID
    // convertUTCToIST(dateString: string): string {
    //   const utcDate = new Date(dateString); // Convert string to Date object
    //   const istDate = new Date(utcDate.getTime() - (330 * 60 * 1000)); // IST is UTC + 5:30
    //   return this.datePipe.transform(istDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
    // }

  ngOnInit(): void {
    // this.tempCo = sessionStorage.getItem('TemplateCode');
    this.StudentDocumentID = sessionStorage.getItem('StudentDocumentID');
    this.getHistory();
    this.getData()
  }

getHistory(){
  this.totalpaid = 0;
  // this.spinner.show();
  let payload = {};
  payload['FeeTemplateCode'] =  this.data.Temp;
  payload['StuId'] =   this.data.StuId;
  payload['FeeHistory'] =  1;
  payload['SnNo'] = this.data.SnNo
this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
  this.payHistoryData = res.data;
  this.payHistoryData.forEach((element,i) => {
    if(i == res.data.length-1){
      this.totalpaid = element.TotalPaidAmount;
    }
  });
})

}

getData() {
  this.spinner.show();
  const payload = {};
  payload['TemplateCode'] = this.data.Temp;
  payload['FeeType'] = ''
  // this.disablePaid = true;
  this.umsService.getFeeTemplet(payload).subscribe((res) => {
    this.spinner.hide()
    let data = res.data[0];
    this.Currency = res.data[0].Currency
    
  });
}
close(){
  this.dialogRef1.close();
  }
  convertUTCToIST(dateString: string): string {
    const utcDate = new Date(dateString); // Convert string to Date object
    // Directly use the date pipe with 'Asia/Kolkata' time zone
    return this.datePipe.transform(utcDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
  }

}
